import * as Sentry from '@sentry/react';

export type ErrorCategory =
  | 'data_load'
  | 'data_save'
  | 'generation'
  | 'chat'
  | 'auth'
  | 'notification'
  | 'export'
  | 'search';

const FALLBACK_MESSAGES: Record<ErrorCategory, string> = {
  data_load: "Couldn't load your data right now — give it another try in a moment.",
  data_save: "That didn't save — try again in a moment.",
  generation: "Romy couldn't generate that right now. Give it another try.",
  chat: "Romy's having trouble connecting. Try sending that again in a moment.",
  auth: "We couldn't sign you in right now. Please try again.",
  notification: "Notifications couldn't be set up right now. You can try again later.",
  export: "Your data export didn't go through. Please try again.",
  search: "Search didn't work just now — try again in a moment.",
};

/**
 * Report an error to Sentry with structured tags and return a user-friendly message.
 * The caller shows the returned string to the user — never the raw error.
 */
export function reportError(
  error: unknown,
  category: ErrorCategory,
  context?: Record<string, string>
): string {
  const err = error instanceof Error ? error : new Error(String(error));

  Sentry.captureException(err, {
    tags: { errorCategory: category },
    extra: context,
  });

  return FALLBACK_MESSAGES[category];
}
